// 篮子类型
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("basketType") || ""
}

const getters = {
  getBasketType:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("basketType",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("basketType")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}